import { TargetSetting } from './TargetSetting';
import MetricSetting from './MetricSetting';

import * as C from '../../options/styles';
import { FIELD_PANEL_KEY } from '../consts';

export const GoalMetricsSetting = {
    name: 'PanelGoalMetricsOption',
    props: {
        currentList: {
            type: Array,
            default() {
                return [];
            },
        },
        canEditCustomMetric: {
            type: Boolean,
            default: true,
        },
        selectedSource: {
            type: Array,
            default() {
                return [];
            },
        },
        currentBreakdownIds: {
            type: Array,
            default() {
                return [];
            },
        },
        isAnalytic: {
            type: Boolean,
            default: false,
        },
        teamspaceId: Number,
        currentViewId: [Number, String],
        widgetType: String,
        isTemplateView: Boolean,
    },
    render() {
        const {
            selectedSource,
            currentBreakdownIds,
            isAnalytic,
            teamspaceId,
            currentViewId,
            widgetType,
            currentList,
            canEditCustomMetric,
            isTemplateView,
        } = this;

        return (
            <C.ComponentWrapper>
                <MetricSetting
                    panelKey={FIELD_PANEL_KEY.GOAL_METRICS()}
                    currentList={currentList}
                    canEditCustomMetric={canEditCustomMetric}
                    selectedSource={selectedSource}
                    currentBreakdownIds={currentBreakdownIds}
                    isAnalytic={isAnalytic}
                    teamspaceId={teamspaceId}
                    currentViewId={currentViewId}
                    widgetType={widgetType}
                    isTemplateView={isTemplateView}
                    onUpdate={(updated) => this.$emit('update', updated)}
                />

                <div style={{ margin: '0 0 15px 0' }}></div>

                <TargetSetting
                    currentList={currentList}
                    canEditCustomMetric={canEditCustomMetric}
                    selectedSource={selectedSource}
                    currentBreakdownIds={currentBreakdownIds}
                    isAnalytic={isAnalytic}
                    teamspaceId={teamspaceId}
                    currentViewId={currentViewId}
                    widgetType={widgetType}
                    isTemplateView={isTemplateView}
                    onUpdate={(updated) => this.$emit('update', updated)}
                />
            </C.ComponentWrapper>
        );
    },
};

export default GoalMetricsSetting;
